import { TemplateModel } from '@picsart/growth-rc/Template';
import { TemplateModel as TemplateModelType } from 'templates/types';
import { FetchedTemplateModel } from 'types/global';

const processBackEndData = (
  data: FetchedTemplateModel[] | TemplateModel[],
): TemplateModelType[] => {
  return data.map(item => ({
    id: Number(item.id),
    commercial: item.commercial,
    width: item.width,
    height: item.height,
    is_paid: item.is_paid,
    license: item.license,
    url: item.url,
    type: item.type,
    display_name: '',
    duration: item.duration,
    animated_preview_info: item.animated_preview_info,
    subtypes: [''],
    classes: [''],
  }));
};

export default processBackEndData;
